import type { ComponentProps } from 'react'
import React, { forwardRef } from 'react'
import TextInputOnly from './TextInputOnly'
import InputLabelWrap from './InputLabelWrap'

interface Props extends Omit<ComponentProps<typeof TextInputOnly>, 'ref'> {
  label?: React.ReactNode
  optionalIndicatorEnabled?: boolean
  uppercase?: boolean
}

const TextInput = forwardRef<HTMLInputElement | null, Props>((props, ref) => {
  const {
    className,
    label,
    style,
    optionalIndicatorEnabled,
    hidden,
    ...inputProps
  } = props

  return (
    <InputLabelWrap
      label={label}
      style={style}
      className={className}
      required={inputProps.required}
      optionalIndicatorEnabled={optionalIndicatorEnabled}
      hidden={hidden}
    >
      <TextInputOnly {...inputProps} ref={ref} />
    </InputLabelWrap>
  )
})

TextInput.displayName = 'TextInput'

export default TextInput
